import React, { useEffect, useState } from "react";
import { MainNavProps } from "../navigation/main/MainParamList";
import {
  Str_ChatRecord,
  Str_GroupChat,
  Str_RelatedChatRecords,
} from "../../language/string_res";
import {
  color_333333,
  color_999999,
  white,
} from "../../assets/style/colors";
import {
  ActivityIndicator,
  Pressable,
  SectionList,
  StyleSheet,
  View,
} from "react-native";
import { User } from "../../../imsdk/db/t_user";
import { getUserName } from "./chat-helper";
import { LeftView } from "./CListItem";
import * as ImSdk from "../../../imsdk/api";
import { Avatar } from "../../../imsdk/api/topic";
import time from "../../../imsdk/time";
import { isGroupTopic } from "../../utils/utils";
import { parseSingleOther } from "../../utils/helper";
import { Group } from "../../../imsdk/db/t_group";
import { CommonText, Div, SectionHeader } from "./ChatSearch";
import { useIsFocused } from "@react-navigation/native";
import { ScreenCloseModal } from "../../components/ScreenModal";
import { ChatSearchInput } from "./components/ChatSearchInput";

type ChatSearchData = {
  title: string;
  data: { subText: string; data: any }[];
};
let isFirst = true;
let hasMore = true;
let searchTimer: any = null;
let tids: string[] = [];

export const MoreChatMsgSearch = ({
  navigation,
  route,
}: MainNavProps<"MoreChatMsgSearch">) => {
  const { curSearch, data } = route.params;
  const [searchText, setSearchText] = useState(curSearch);
  const [section, setSection] = useState<ChatSearchData[]>([]);
  const isFocused = useIsFocused();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isFocused && data && data.length > 0) {
      setSection([
        {
          title: Str_ChatRecord,
          data: data,
        },
      ]);
      tids = [];
      data.forEach((v) => {
        const item = v as { data: { tid: string } };
        tids.push(item.data.tid);
      });
    }
    hasMore = data.length === 20;
  }, [isFocused, data]);
  const onChangeText = (text: string) => {
    // 清除之前的定时器（如果有）
    if (searchTimer) {
      clearTimeout(searchTimer);
    }
    setSearchText(text);
    // 设置新的定时器
    searchTimer = setTimeout(() => {
      // 定时器到期，执行搜索
      tids = [];
      startSearch(text);
      // 这里可以替换为实际的搜索逻辑
    }, 500);
  };
  const startSearch = (text: string, isLoad: boolean = false) => {
    const sections: ChatSearchData[] = [];
    if (text.length === 0) {
      setSection(sections);
      return;
    }
    const searchMsg = async () => {
      let data: { data: any; subText: string }[] = [];
      async function GetGroupDetail(tid: string, total: number) {
        const r = await ImSdk.getInstance().GetGroupDetail(tid, true);
        if (r.group) {
          data.push({
            data: { tid: tid, data: r.group },
            subText: `${total}${Str_RelatedChatRecords}`,
          });
        }
      }

      async function GetUserDetail(tid: string, total: number) {
        const uid = parseSingleOther(tid);
        if (uid > 0) {
          const r = await ImSdk.getInstance().GetUser(uid, true);
          if (r.user) {
            data.push({
              data: { tid: tid, data: r.user },
              subText: `${total}${Str_RelatedChatRecords}`,
            });
          }
        }
      }
      const r = await ImSdk.getInstance().QueryMsg(
        text,
        time.toUnixMillSecond(time.now()),
        tids
      );
      hasMore = r.data?.length === 20;
      if (r.data && r.data.length > 0) {
        const n = r.data.length;
        for (let i = 0; i < n; i++) {
          const item = r.data[i];
          tids.push(item.tid);
          const isGroup = isGroupTopic(item.tid);
          if (isGroup) {
            await GetGroupDetail(item.tid, item.total);
          } else {
            await GetUserDetail(item.tid, item.total);
          }
        }

        const l = data.length;

        if (data.length > 0) {
          if (isLoad) {
            section[0].data.push(...data);
            sections.push(...section);
          } else {
            const item: ChatSearchData = {
              title: Str_ChatRecord,
              data: data,
            };
            sections.push(item);
          }
        }
      }
    };
    setIsLoading(true);
    searchMsg().then((r) => {
      isFirst = false;
      setSection(sections);
      setIsLoading(false);
    });
  };

  function loadmore() {
    if (!isLoading && hasMore) {
      startSearch(searchText, true);
    }
  }

  const RenderItem = ({
    item,
    index,
  }: {
    item: { subText: string; data: any };
    index: number;
  }) => {
    const record = item.data as { tid: string; data: any };
    const tid = record.tid;
    const isGroup = isGroupTopic(tid);
    let name = "";
    let avatar = "";
    let isAdmin = false;
    let uid = 0;
    if (isGroup) {
      const group = record.data as Group;
      if (group?.adminUids) {
        const curUid = ImSdk.getInstance().CurrentUid();
        if (curUid !== 0 && group.adminUids.includes(curUid)) {
          isAdmin = true;
        }
      }
      name = group.remark || group.name || Str_GroupChat;
      avatar = group.avatar;
    } else {
      const user = record.data as User;
      name = getUserName(user);
      avatar = user.avatar;
      uid = user.uid;
    }
    const left: Avatar = { avatar: avatar, name: name, uid: uid };

    const onClick = () => {
      navigation.navigate("SearchChatResultScreen", {
        tid: tid,
        isAdmin: isAdmin,
        curSearch: searchText,
      });
    };
    return (
      <Pressable onPress={onClick} style={styles.userContainer}>
        <LeftView left={left} size={40} isRounded={true} isGroup={isGroup} />
        {CommonText(`${index}_${name}`, item.subText)}
      </Pressable>
    );
  };

  // 渲染底部加载提示
  const ListFooterComponent = () => (
    <View style={{ padding: 20, alignItems: "center" }}>
      {isLoading && <ActivityIndicator size="large" color="#0000ff" />}
    </View>
  );

  return (
    <ScreenCloseModal>
      <ChatSearchInput searchText={searchText} onChangeText={onChangeText} />
      <SectionList
        sections={section}
        keyExtractor={(item, index) => index.toString()}
        renderItem={RenderItem}
        onEndReached={loadmore}
        onEndReachedThreshold={0.3}
        ItemSeparatorComponent={Div}
        ListFooterComponent={ListFooterComponent}
        renderSectionHeader={({ section }) => (
          <SectionHeader title={section.title} />
        )}
      />
    </ScreenCloseModal>
  );
};
const styles = StyleSheet.create({

  userContainer: {
    flexDirection: "row",
    backgroundColor: white,
    paddingVertical: 8,
    paddingHorizontal: 12,
    alignItems: "center",
  },
  userTitle: {
    color: color_333333,
    fontSize: 14,
    width: "100%",
    fontWeight: "bold",
    fontFamily: "",
  },
  subUserTitle: {
    color: color_999999,
    width: "100%",
    fontSize: 12,
  },
});
